import React from "react";
import Box from "@mui/joy/Box";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import { Card } from "@mui/joy";
import Divider from "@mui/joy/Divider";

export default function TerminsoyCondiciones() {
  let Header = () => {
    return (
      <Box>
        <AspectRatio
          variant="plain"
          ratio="1"
          sx={{
            width: "100px",
            marginBottom: "2rem",
            borderRadius: "12px",
          }}
        >
          <img src={logo} alt="logo" style={{ objectFit: "contain" }} />
        </AspectRatio>
        <Typography level="h1">Términos y Condiciones</Typography>
        <Box>
          <Typography>Email: contacto@amigoutdoors.com</Typography>
        </Box>
      </Box>
    );
  };

  let Body = () => {
    return (
      <Box
        sx={{
          display: "grid",
          gap: 1.5,
          maxHeight: "70vh",
          padding: 2,
        }}
      >
        <Divider />

        <Box>
          <Titulo x={"1. Aceptación"} />
          <Parrafo
            x={`Al descargar, instalar o usar la aplicación AmigOutdoors (la “App”) aceptas estos Términos y Condiciones y la Política de Privacidad. Si no estás de acuerdo, no uses la App.`}
          />
        </Box>

        <Box>
          <Titulo x={"2. Objeto del servicio"} />
          <Parrafo
            x={`AmigOutdoors es una plataforma que facilita la conexión entre personas mayores de 18 años interesadas en actividades al aire libre (trekking, camping, salidas). La App permite crear perfiles, publicar y unirse a “aventuras”, enviar mensajes y recibir notificaciones push. Nosotros no organizamos físicamente salidas ni proveemos guías; solo facilitamos la conexión digital.`}
          />
        </Box>

        <Box>
          <Titulo x={"3. Edad mínima"} />
          <Parrafo
            x={`La App es solo para mayores de 18 años. Al usarla confirmas que tienes 18 años o más. Si detectamos o nos informan que un titular es menor de edad, podemos eliminar su cuenta.`}
          />
        </Box>

        <Box>
          <Titulo x={"4. Cuentas y veracidad de la información"} />
          <Parrafo
            x={`Debes registrar información veraz. La verificación de identidad puede ser solicitada; salvo que se indique lo contrario, AmigOutdoors no garantiza que los perfiles sean reales o veraces. Eres responsable por la seguridad de tu cuenta y por mantener la confidencialidad de tus credenciales.`}
          />
        </Box>

        <Box>
          <Titulo x={"5. Contenido generado por usuarios"} />
          <Parrafo
            x={`Los usuarios pueden publicar textos, fotos, ubicaciones y organizar eventos (“Contenido de Usuario”). Cada usuario es totalmente responsable del contenido que publique y debe respetar la normativa aplicable. AmigOutdoors podrá eliminar contenido que viole estos Términos o la ley.`}
          />
        </Box>

        <Box>
          <Titulo x={"6. Conducta prohibida"} />
          <Parrafo
            x={`Está prohibido (entre otros): publicar contenidos ilegales, acosar, suplantar personas, promover daños, usar la App para fines comerciales sin autorización, interferir con la App, o subir material con derechos de autor sin permiso.`}
          />
        </Box>

        <Box>
          <Titulo x={"7. Seguridad y recomendaciones"} />
          <Parrafo
            x={`AmigOutdoors no organiza ni supervisa físicamente los encuentros. Cualquier actividad física implica riesgos. Recomendamos: quedar en lugares públicos, avisar a familiares, compartir ruta, revisar estado físico y meteorológico, usar equipo adecuado y contratar seguro si procede. La App puede ofrecer herramientas de verificación o reseñas, pero no garantiza la idoneidad, competencia o conducta de otros usuarios.`}
          />
        </Box>

        <Box>
          <Titulo x={"8. Exclusión y limitación de responsabilidad"} />
          <Parrafo
            x={`EXCLUSIÓN: AmigOutdoors, sus propietarios, empleados, contratistas y afiliados NO serán responsables por daños personales, lesiones, pérdidas, robos, hechos ilícitos, daños materiales o morales que ocurran antes, durante o después de una aventura organizada a través de la App, salvo que la ley vigente establezca lo contrario. No garantizamos disponibilidad ininterrumpida del servicio, exactitud completa del contenido ni que la App esté libre de errores o vulnerabilidades. Estas limitaciones se aplican en la máxima medida permitida por la ley aplicable.`}
          />
        </Box>

        <Box>
          <Titulo x={"9. Pagos y servicios de terceros"} />
          <Parrafo x={`Actualmente no se reciben pagos a través de la App. `} />
        </Box>

        <Box>
          <Titulo x={"10. Propiedad intelectual"} />
          <Parrafo
            x={`La App y sus contenidos originales son propiedad de "Diego Rosas". Los usuarios conservan los derechos sobre el contenido que publiquen, aunque otorgan a AmigOutdoors una licencia limitada para usarlo en la plataforma (mostrar, distribuir, copiar, moderar).`}
          />
        </Box>

        <Box>
          <Titulo x={"11. Suspensión y terminación"} />
          <Parrafo
            x={`Podemos suspender o eliminar cuentas por incumplimiento, por seguridad o por decisiones administrativas. Los usuarios pueden eliminar su cuenta enviandonos un correo a contacto@amigoutdoors.com.`}
          />
        </Box>

        <Box>
          <Titulo x={"12. Indemnidad"} />
          <Parrafo
            x={`Aceptas indemnizar y mantener indemne a AmigOutdoors frente a reclamaciones, pérdidas y gastos derivados de tu uso de la App o violación de estos Términos.`}
          />
        </Box>

        <Box>
          <Titulo x={"13. Modificaciones"} />
          <Parrafo
            x={`Podemos modificar estos Términos; se publicará la versión actualizada en la App y, cuando corresponda, se solicitará el consentimiento del usuario.`}
          />
        </Box>

        <Box>
          <Titulo x={"14. Ley aplicable y jurisdicción"} />
          <Parrafo
            x={`Estos Términos se rigen por las leyes de Chile. Para disputas, las partes se someten a los tribunales competentes de Concepción.`}
          />
        </Box>

        <Box>
          <Titulo x={"15. Contacto"} />
          <Parrafo x={`Dudas o solicitudes: contacto@amigoutdoors.com.`} />
        </Box>

        <Divider />

        {/* -- POLÍTICA DE PRIVACIDAD -- */}
        <Box>
          <Titulo x={"Política de Privacidad"} />
          <Parrafo
            x={`Esta Política explica qué datos recopilamos, por qué los usamos y cómo puedes ejercer tus derechos.`}
          />
        </Box>

        <Box>
          <Titulo x={"Responsable del tratamiento"} />
          <Parrafo x={` Email: contacto@amigoutdoors.com`} />
        </Box>

        <Box>
          <Titulo x={"Datos que recopilamos"} />
          <Parrafo
            x={`Datos de cuenta / registro: nombre, correo electrónico, foto de perfil, fecha de nacimiento (confirmación 18+), género, descripción.\nDatos de perfil público: fotos, valoraciones, intereses, rutas publicadas.\nComunicación: mensajes privados entre usuarios (almacenados en servidores), historial de participación en actividades.\nDatos de ubicación: ubicación aproximada o exacta si habilitas funciones de geolocalización para emparejar rutas o mostrar aventuras cercanas.\nDatos del dispositivo y uso: tipo de dispositivo, sistema operativo, identificadores de dispositivo, token de notificaciones push, direcciones IP, registros de actividad (logs) y analítica (para mejorar el servicio).\nDatos opcionales y sensibles: la App no solicitará datos sensibles (salud, religión, orientación sexual, raza). Si el usuario añade voluntariamente datos sensibles en su perfil, el responsable no los tratará salvo consentimiento expreso y conforme a la ley aplicable.`}
          />
        </Box>

        <Box>
          <Titulo x={"Finalidades del tratamiento"} />
          <Parrafo
            x={`- Proveer, operar y mantener la App.\n- Gestionar cuentas y autenticación.\n- Facilitar la conexión entre usuarios y organización de aventuras.\n- Enviar notificaciones push (alertas de mensajes, recordatorios de actividad).\n- Mejorar la App mediante analítica y diagnóstico.\n- Cumplir obligaciones legales y responder a incidentes de seguridad.`}
          />
        </Box>

        <Box>
          <Titulo x={"Base legal para el tratamiento"} />
          <Parrafo
            x={`- Consentimiento: para datos sensibles, envío de comunicaciones de marketing (si las hubiera) y tratamiento de datos no necesarios para la prestación del servicio.\n- Ejecución del servicio / contrato: tratamiento necesario para ofrecer la App (por ejemplo, gestionar cuenta, mensajería, emparejamiento).\n- Interés legítimo: mejoras de producto, prevención de fraude y seguridad (cuando no prevalezca el derecho del usuario).`}
          />
        </Box>

        <Box>
          <Titulo x={"Conservación de datos"} />
          <Parrafo
            x={`Conservaremos tus datos mientras tu cuenta esté activa y por el tiempo necesario para cumplir finalidades legales o para responder reclamaciones. Podrás solicitar la supresión, rectificación o acceso según lo indicado más abajo.`}
          />
        </Box>

        <Box>
          <Titulo x={"Compartir datos y terceros"} />
          <Parrafo
            x={`- Proveedores de servicios: hosting, notificaciones push (p. ej. Firebase), procesamiento de pagos si se implementan en el futuro, servicios de analítica. Compartiremos datos estrictamente necesarios con esos proveedores bajo contratos que garanticen seguridad.\n- Obligación legal: podremos divulgar datos ante requerimientos judiciales o autoridades competentes.\n- Transferencias internacionales: los proveedores pueden almacenar datos fuera de Chile. En caso de transferencias internacionales adoptaremos medidas razonables de protección (cláusulas, acuerdos), según la ley aplicable.`}
          />
        </Box>

        <Box>
          <Titulo x={"Seguridad"} />
          <Parrafo
            x={`Implementamos medidas técnicas y organizativas razonables (cifrado en tránsito, controles de acceso, backups) para proteger los datos. No obstante, ninguna medida es 100% segura; en caso de incidente notificaremos conforme a la ley aplicable.`}
          />
        </Box>
        <Box>
          <Titulo x={"Menores"} />
          <Parrafo
            x={`No recopilamos intencionalmente datos de menores de 18 años. Si detectamos que la cuenta pertenece a un menor, la eliminaremos y bloquearemos el acceso.`}
          />
        </Box>

        <Box>
          <Titulo x={"Cookies y tecnologías similares"} />
          <Parrafo
            x={`Usaremos cookies o tecnologías equivalentes para funciones operativas y analíticas. En la App móvil, utilizamos identificadores de dispositivo y almacenamiento local.`}
          />
        </Box>

        <Box>
          <Titulo x={"Notificaciones push"} />
          <Parrafo
            x={`Las notificaciones push requieren permisos del usuario. Puedes desactivar las notificaciones desde la configuración de la App o del sistema operativo. Para funcionar guardamos el token de notificación (push token).`}
          />
        </Box>

        <Box>
          <Titulo x={"Cambios en la política"} />
          <Parrafo
            x={`Nos reservamos el derecho a modificar esta Política; cuando los cambios sean significativos te informaremos con antelación razonable y solicitaremos consentimiento si la ley lo exige.`}
          />
        </Box>

        <Box>
          <Titulo x={"Contacto y reclamaciones"} />
          <Parrafo x={`Contacto: contacto@amigoutdoors.com`} />
        </Box>

        <Divider />

        {/* -- CONSEJOS DE SEGURIDAD (opcional) -- */}
        <Box>
          <Titulo x={"Consejos de seguridad para usuarios"} />
          <Parrafo
            x={`- Reúnete por primera vez en lugares públicos y concurridos.\n- Informa a un familiar o amigo sobre tus planes y ruta.\n- Revisa el clima y lleva equipo adecuado.\n- Considera contratar un seguro de actividades al aire libre.\n- Confía en tu intuición; si algo te hace sentir inseguro, retírate.`}
          />
        </Box>

        <Divider />
      </Box>
    );
  };
  let Titulo = ({ x }) => {
    return (
      <Typography level="h3" marginBottom={2} marginTop={1}>
        {x}
      </Typography>
    );
  };
  let Parrafo = ({ x }) => {
    return <Typography level={"body-md"}>{x}</Typography>;
  };

  let logo = `${process.env.REACT_APP_FRONTEND_URL}/uploads/logo.svg`;
  return (
    <Box
      flex={1}
      marginLeft={{ md: 40 }}
      marginRight={{ md: 40 }}
      marginTop={{ md: 10 }}
      marginBottom={{ md: 10 }}
    >
      <Card
        variant="soft"
        sx={{ minHeight: { md: "600vh", xs: "1210vh" }, padding: { md: 6 } }}
      >
        <Header />
        <Body />
      </Card>
    </Box>
  );
}
